import { render, staticRenderFns } from "./ApprovedTab.vue?vue&type=template&id=5dfdbb68"
import script from "./ApprovedTab.vue?vue&type=script&lang=js"
export * from "./ApprovedTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports